export default __webpack_public_path__ + "static/compareItemImg4-e2e7786d0fa60d669498c48a9f3a7c79.webp";